import React, {useContext} from "react";
import "./Hobbies.scss";
import {hobbiesSection} from "../../portfolio";
import {Fade} from "react-reveal";
import StyleContext from "../../contexts/StyleContext";

export default function Hobbies() {
  const {isDark} = useContext(StyleContext);
  if (!hobbiesSection.display) {
    return null;
  }
  return (
    <Fade bottom duration={1000} distance="20px">
      <div className="main" id="hobbies">
        <div className="hobbies-main-div">
          <div className="hobbies-header">
            <h1
              className={
                isDark
                  ? "dark-mode heading hobbies-heading"
                  : "heading hobbies-heading"
              }
            >
              {hobbiesSection.title}
            </h1>
            <p
              className={
                isDark
                  ? "dark-mode subTitle hobbies-subtitle"
                  : "subTitle hobbies-subtitle"
              }
            >
              {hobbiesSection.subtitle}
            </p>
          </div>
          <div className="hobbies-cards-div">
            {hobbiesSection.hobbies.map((hobby, i) => {
              return (
                <div
                  key={i}
                  className={
                    isDark
                      ? "dark-mode hobby-card hobby-card-dark"
                      : "hobby-card hobby-card-light"
                  }
                >
                  <div className="hobby-icon">{hobby.icon}</div>
                  <h5
                    className={isDark ? "dark-mode hobby-title" : "hobby-title"}
                  >
                    {hobby.name}
                  </h5>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </Fade>
  );
}



